import { Icon } from "components/icons/icon"
import { FC, ReactNode } from "react"

interface PricingSideMenuCardProps {
  children: ReactNode
  title: string
  icon?: string
  titleAside?: ReactNode
  className?: string
  disabled?: boolean
}

export const PricingSideMenuCard: FC<PricingSideMenuCardProps> = ({
  children,
  title,
  icon,
  titleAside,
  className = "",
  disabled = false
}) => {
  const disabledStyle = disabled ? "opacity-50 cursor-not-allowed" : "";

  return (
    <div
      className={`p-4 bg-white rounded-xl border shadow ${className} ${disabledStyle}`}
      aria-disabled={disabled}
    >
      {/* Header */}
      <div className="mb-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          {icon && (
            <Icon name={icon} styles="" width="18" height="18" />
          )}
          <p>{title}</p>
        </div>
        {titleAside && (
          <div className="flex items-center">
            {titleAside}
          </div>
        )}
      </div>
        {children}
    </div>
  )
}
